import { KeywordAgentTerm, KeywordAgentTermStatus } from "../api/keyword-agent";

export type TermState = "pending" | "excluded" | "restored" | "kept";

// `excluded?` — whether an exclusion is standing right now — deliberately
// doesn't decide this: a paused agent holds none of its exclusions, and a
// log that emptied itself every time somebody paused would be no log.
export const getTermState = (term: KeywordAgentTerm): TermState => {
  if (term["restored?"]) {
    return "restored";
  }
  if (term.status === KeywordAgentTermStatus.REJECTED) {
    return "excluded";
  }
  return term.status === KeywordAgentTermStatus.IN_REVIEW ? "pending" : "kept";
};

export const filterTerms = (
  terms: KeywordAgentTerm[],
  { state, query }: { state?: TermState; query?: string } = {},
): KeywordAgentTerm[] => {
  const needle = query?.trim().toLowerCase();
  return terms.filter((term) => {
    if (state !== undefined && getTermState(term) !== state) {
      return false;
    }
    return !needle || term.term.toLowerCase().includes(needle);
  });
};
